<script lang="ts">
  // Blocked-images note (spec §10): show once, or always for this sender.
  import { t } from '$lib/i18n';

  let { onshow, onalways }: { onshow: () => void; onalways: () => void } = $props();
</script>

<div class="images-note">
  <button type="button" class="inline-link" onclick={onshow}>{t('imagesBlocked')}, <u>{t('showImages')}</u></button>
  <button type="button" class="inline-link" onclick={onalways}>{t('alwaysImages')}</button>
</div>

<style>
  /* svelte-rwh28b (Reader) — images note (both rules of the bundle, in order) */
  .images-note {
    display: block;
    width: 100%;
    text-align: start;
    background: var(--info-100);
    color: var(--blue-700);
    border-radius: var(--radius-md);
    padding: var(--space-3) var(--space-4);
    font-size: var(--text-sm);
    margin-bottom: var(--space-4)
  }

  .images-note {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-3)
  }

  .inline-link {
    border: 0;
    background: none;
    padding: 6px 0;
    cursor: pointer;
    color: var(--text-muted);
    font: inherit;
    font-size: var(--text-xs);
    text-align: start
  }

  .inline-link:hover {
    color: var(--text-body)
  }
</style>
